import React from 'react'
import { FaGithub, FaLinkedin } from 'react-icons/fa'
import { HiOutlineMail } from 'react-icons/hi'
import { BsFillPersonLinesFill } from 'react-icons/bs'


const SocialLinks = () => {

  const links = [

    {
      id: 1,
      child: (
        <>
          LinkedIn <FaLinkedin size={26} />
        </>
      ),
      href: 'https://linkedin.com',
      style: 'rounded-tr-md'
    },
    {
      id: 2,
      child: (
        <>
          GitHub <FaGithub size={26} />
        </>
      ),
      href: 'https://github.com/roxannezhao199',
    },
    {
      id: 3,
      child: (
        <>
          Mail <HiOutlineMail size={26} />
        </>
      ),
      href: 'mailto:roxannezhao199@gmail.com',
    },
    {
      id: 4,
      child: (
        <>
          Resume <BsFillPersonLinesFill size={26} />
        </>
      ),
      href: 'https://drive.google.com/file/d/1r-ksgBfLe4rNE8E2CUz9249XyFR3mlo9/view?usp=sharing',
      style: 'rounded-br-md',
      download: true,
    }
  ]


  return (
    <div className='hidden lg:flex flex-col top-[30%] left-0 fixed'>
      <ul>
        {links.map(({ id, child, href, style, download}) => (
          <li key={id} className={`flex justify-between items-center w-40 h-12 px-3 ml-[-114px] hover:ml-[-10px] hover:rounded-md duration-300  bg-gray-500 ${style}`}>
            <a href={href} className='flex justify-between items-center w-full text-white' download={download} target='_blank' rel="noreferrer">
              {child}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default SocialLinks
